import { useLog } from '@/utils/logger';

export const LoggerPlugin = {
  install(Vue) {
    Vue.prototype.$log = useLog;
  }
};
